// source: thirdparty.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var Protos_common_pb = require('./common_pb.js');
goog.object.extend(proto, Protos_common_pb);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.ResultCase', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.Organization', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.ResultCase', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay', null, global);
goog.exportSymbol('proto.dimensionsClientPortal_thirdparty_endpoint.UserType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.Organization, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.Organization.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.Organization';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.UserType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.UserType.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.UserType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.oneofGroups_);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.oneofGroups_);
};
goog.inherits(proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.displayName = 'proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
username: jspb.Message.getFieldWithDefault(msg, 1, ""),
fcmtoken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest;
  return proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFcmtoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFcmtoken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string fcmToken = 2;
 * @return {string}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.prototype.getFcmtoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientRequest.prototype.setFcmtoken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
business: jspb.Message.getFieldWithDefault(msg, 1, ""),
preferredname: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest;
  return proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBusiness(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPreferredname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusiness();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPreferredname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string business = 1;
 * @return {string}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.prototype.getBusiness = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.prototype.setBusiness = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string preferredName = 2;
 * @return {string}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.prototype.getPreferredname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientRequest.prototype.setPreferredname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.Organization.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
domain: (f = msg.getDomain()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
subscription: (f = msg.getSubscription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.Organization;
  return proto.dimensionsClientPortal_thirdparty_endpoint.Organization.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDomain(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSubscription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.Organization.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDomain();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSubscription();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue domain = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.getDomain = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.setDomain = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.clearDomain = function() {
  return this.setDomain(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.hasDomain = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue subscription = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.getSubscription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.setSubscription = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.Organization} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.clearSubscription = function() {
  return this.setSubscription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.Organization.prototype.hasSubscription = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionid: jspb.Message.getFieldWithDefault(msg, 1, 0),
refreshtoken: (f = msg.getRefreshtoken()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
token: (f = msg.getToken()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
expirationdate: (f = msg.getExpirationdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken;
  return proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSessionid(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRefreshtoken(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setToken(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpirationdate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRefreshtoken();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getToken();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getExpirationdate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 sessionId = 1;
 * @return {number}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.getSessionid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue refreshToken = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.getRefreshtoken = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.setRefreshtoken = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.clearRefreshtoken = function() {
  return this.setRefreshtoken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.hasRefreshtoken = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue token = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.getToken = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.setToken = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.clearToken = function() {
  return this.setToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.hasToken = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp expirationDate = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.getExpirationdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.setExpirationdate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.clearExpirationdate = function() {
  return this.setExpirationdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.prototype.hasExpirationdate = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.UserType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.UserType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.UserType}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.UserType;
  return proto.dimensionsClientPortal_thirdparty_endpoint.UserType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.UserType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.UserType}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.UserType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.UserType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.UserType} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue name = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.UserType} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.UserType} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.UserType.prototype.hasName = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountid: jspb.Message.getFieldWithDefault(msg, 1, 0),
username: (f = msg.getUsername()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
accountphonenumber: (f = msg.getAccountphonenumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
accountemail: (f = msg.getAccountemail()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
profile: (f = msg.getProfile()) && Protos_common_pb.ProfileResponse.toObject(includeInstance, f),
accesstoken: (f = msg.getAccesstoken()) && proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.toObject(includeInstance, f),
organization: (f = msg.getOrganization()) && proto.dimensionsClientPortal_thirdparty_endpoint.Organization.toObject(includeInstance, f),
passwordexpirationdate: (f = msg.getPasswordexpirationdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
businessclient: jspb.Message.getFieldWithDefault(msg, 10, ""),
business: (f = msg.getBusiness()) && proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.toObject(includeInstance, f),
internalid: (f = msg.getInternalid()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
image: (f = msg.getImage()) && Protos_common_pb.File.toObject(includeInstance, f),
usertype: (f = msg.getUsertype()) && proto.dimensionsClientPortal_thirdparty_endpoint.UserType.toObject(includeInstance, f),
identityconfirmationstatus: (f = msg.getIdentityconfirmationstatus()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply;
  return proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountid(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUsername(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAccountphonenumber(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAccountemail(value);
      break;
    case 5:
      var value = new Protos_common_pb.ProfileResponse;
      reader.readMessage(value,Protos_common_pb.ProfileResponse.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    case 6:
      var value = new proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken;
      reader.readMessage(value,proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.deserializeBinaryFromReader);
      msg.setAccesstoken(value);
      break;
    case 8:
      var value = new proto.dimensionsClientPortal_thirdparty_endpoint.Organization;
      reader.readMessage(value,proto.dimensionsClientPortal_thirdparty_endpoint.Organization.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPasswordexpirationdate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBusinessclient(value);
      break;
    case 11:
      var value = new proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay;
      reader.readMessage(value,proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.deserializeBinaryFromReader);
      msg.setBusiness(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setInternalid(value);
      break;
    case 13:
      var value = new Protos_common_pb.File;
      reader.readMessage(value,Protos_common_pb.File.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    case 14:
      var value = new proto.dimensionsClientPortal_thirdparty_endpoint.UserType;
      reader.readMessage(value,proto.dimensionsClientPortal_thirdparty_endpoint.UserType.deserializeBinaryFromReader);
      msg.setUsertype(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setIdentityconfirmationstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAccountphonenumber();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAccountemail();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      Protos_common_pb.ProfileResponse.serializeBinaryToWriter
    );
  }
  f = message.getAccesstoken();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken.serializeBinaryToWriter
    );
  }
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.dimensionsClientPortal_thirdparty_endpoint.Organization.serializeBinaryToWriter
    );
  }
  f = message.getPasswordexpirationdate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBusinessclient();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getBusiness();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.serializeBinaryToWriter
    );
  }
  f = message.getInternalid();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      Protos_common_pb.File.serializeBinaryToWriter
    );
  }
  f = message.getUsertype();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.dimensionsClientPortal_thirdparty_endpoint.UserType.serializeBinaryToWriter
    );
  }
  f = message.getIdentityconfirmationstatus();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 accountId = 1;
 * @return {number}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getAccountid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue username = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getUsername = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setUsername = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearUsername = function() {
  return this.setUsername(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasUsername = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue accountPhoneNumber = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getAccountphonenumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setAccountphonenumber = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearAccountphonenumber = function() {
  return this.setAccountphonenumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasAccountphonenumber = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue accountEmail = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getAccountemail = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setAccountemail = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearAccountemail = function() {
  return this.setAccountemail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasAccountemail = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional dimensionsClientPortal_common.ProfileResponse profile = 5;
 * @return {?proto.dimensionsClientPortal_common.ProfileResponse}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getProfile = function() {
  return /** @type{?proto.dimensionsClientPortal_common.ProfileResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.ProfileResponse, 5));
};


/**
 * @param {?proto.dimensionsClientPortal_common.ProfileResponse|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional AccessToken accessToken = 6;
 * @return {?proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getAccesstoken = function() {
  return /** @type{?proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken} */ (
    jspb.Message.getWrapperField(this, proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken, 6));
};


/**
 * @param {?proto.dimensionsClientPortal_thirdparty_endpoint.AccessToken|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setAccesstoken = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearAccesstoken = function() {
  return this.setAccesstoken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasAccesstoken = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Organization organization = 8;
 * @return {?proto.dimensionsClientPortal_thirdparty_endpoint.Organization}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getOrganization = function() {
  return /** @type{?proto.dimensionsClientPortal_thirdparty_endpoint.Organization} */ (
    jspb.Message.getWrapperField(this, proto.dimensionsClientPortal_thirdparty_endpoint.Organization, 8));
};


/**
 * @param {?proto.dimensionsClientPortal_thirdparty_endpoint.Organization|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp passwordExpirationDate = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getPasswordexpirationdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setPasswordexpirationdate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearPasswordexpirationdate = function() {
  return this.setPasswordexpirationdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasPasswordexpirationdate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string businessClient = 10;
 * @return {string}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getBusinessclient = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setBusinessclient = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional BusinessReplay business = 11;
 * @return {?proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getBusiness = function() {
  return /** @type{?proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay} */ (
    jspb.Message.getWrapperField(this, proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay, 11));
};


/**
 * @param {?proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setBusiness = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearBusiness = function() {
  return this.setBusiness(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasBusiness = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue internalId = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getInternalid = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setInternalid = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearInternalid = function() {
  return this.setInternalid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasInternalid = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional dimensionsClientPortal_common.File image = 13;
 * @return {?proto.dimensionsClientPortal_common.File}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getImage = function() {
  return /** @type{?proto.dimensionsClientPortal_common.File} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.File, 13));
};


/**
 * @param {?proto.dimensionsClientPortal_common.File|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setImage = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasImage = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional UserType userType = 14;
 * @return {?proto.dimensionsClientPortal_thirdparty_endpoint.UserType}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getUsertype = function() {
  return /** @type{?proto.dimensionsClientPortal_thirdparty_endpoint.UserType} */ (
    jspb.Message.getWrapperField(this, proto.dimensionsClientPortal_thirdparty_endpoint.UserType, 14));
};


/**
 * @param {?proto.dimensionsClientPortal_thirdparty_endpoint.UserType|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setUsertype = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearUsertype = function() {
  return this.setUsertype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasUsertype = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Int32Value identityConfirmationStatus = 15;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.getIdentityconfirmationstatus = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 15));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.setIdentityconfirmationstatus = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.clearIdentityconfirmationstatus = function() {
  return this.setIdentityconfirmationstatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.prototype.hasIdentityconfirmationstatus = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = msg.getId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
metadata: (f = msg.getMetadata()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
organization: (f = msg.getOrganization()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay;
  return proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.getId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue metadata = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.getMetadata = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue organization = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.getOrganization = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = msg.getId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay;
  return proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.prototype.getId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.BusinessReplay.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
message: (f = msg.getMessage()) && Protos_common_pb.MessageResponse.toObject(includeInstance, f),
connection: (f = msg.getConnection()) && proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply;
  return proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 3:
      var value = new Protos_common_pb.MessageResponse;
      reader.readMessage(value,Protos_common_pb.MessageResponse.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 4:
      var value = new proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay;
      reader.readMessage(value,proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.deserializeBinaryFromReader);
      msg.setConnection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      Protos_common_pb.MessageResponse.serializeBinaryToWriter
    );
  }
  f = message.getConnection();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Id = 1;
 * @return {string}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp createdDate = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional dimensionsClientPortal_common.MessageResponse message = 3;
 * @return {?proto.dimensionsClientPortal_common.MessageResponse}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.getMessage = function() {
  return /** @type{?proto.dimensionsClientPortal_common.MessageResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.MessageResponse, 3));
};


/**
 * @param {?proto.dimensionsClientPortal_common.MessageResponse|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ThirdPartySystemLinkReplay connection = 4;
 * @return {?proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.getConnection = function() {
  return /** @type{?proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay} */ (
    jspb.Message.getWrapperField(this, proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay, 4));
};


/**
 * @param {?proto.dimensionsClientPortal_thirdparty_endpoint.ThirdPartySystemLinkReplay|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.setConnection = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.clearConnection = function() {
  return this.setConnection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.prototype.hasConnection = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SUCCESS: 1
};

/**
 * @return {proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.ResultCase}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.prototype.getResultCase = function() {
  return /** @type {proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: (f = msg.getSuccess()) && proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse;
  return proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply;
      reader.readMessage(value,proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply.serializeBinaryToWriter
    );
  }
};


/**
 * optional AuthenticateClientReply success = 1;
 * @return {?proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.prototype.getSuccess = function() {
  return /** @type{?proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply} */ (
    jspb.Message.getWrapperField(this, proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply, 1));
};


/**
 * @param {?proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientReply|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.AuthenticateClientResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SUCCESS: 1
};

/**
 * @return {proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.ResultCase}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.prototype.getResultCase = function() {
  return /** @type {proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: (f = msg.getSuccess()) && proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse;
  return proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply;
      reader.readMessage(value,proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply.serializeBinaryToWriter
    );
  }
};


/**
 * optional RegisterClientReply success = 1;
 * @return {?proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.prototype.getSuccess = function() {
  return /** @type{?proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply} */ (
    jspb.Message.getWrapperField(this, proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply, 1));
};


/**
 * @param {?proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientReply|undefined} value
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse} returns this
*/
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse} returns this
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dimensionsClientPortal_thirdparty_endpoint.RegisterClientResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.dimensionsClientPortal_thirdparty_endpoint);
